import React, { Component } from 'react'
import { connect } from 'react-redux'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Box, TextField, Button, Icon } from '@nike/eds'
import { Section } from '../components/Section.js'

import { getRedirectToken } from './actions.js'
import { selectToken, selectError } from './reducer.js'

import TokenInspector from './TokenInspector.js'
import ClientSelector from './ClientSelector.js'

class TokenBanner extends Component {
  componentDidMount() {
    this.props.getRedirectToken()
  }

  render() {
    let { token, error } = this.props
    if (error) return <Error message={error} />
    token = token && token.toJS()
    return (
      <div>
        <Section title='Get Token'>
          <ClientSelector />
          {token && (
            <div className='token-env-view'>
              <TextField disabled label='Username' value={token.username} />
              <ClipBlock label='Access Token' value={token.accessToken} />
              <ClipBlock label='ID Token' value={token.openIdToken} />
              <TokenInspector claims={token} />
            </div>
          )}
        </Section>
        <Section title='View Token'>
          <TokenInspector />
        </Section>
      </div>
    )
  }
}

function Error({ message }) {
  return (
    <Box>
      <div>
        <h1>Error</h1>
        <p>{message}</p>
      </div>
    </Box>
  )
}

class ClipBlock extends Component {
  constructor(...props) {
    super(...props)
    this.state = { copied: false }
  }
  markCopied = () => {
    this.setState({ copied: true })
    setTimeout(() => this.setState({ copied: false }), 2000)
  }
  render() {
    let { label, value } = this.props
    return (
      <div className='token-input'>
        <TextField disabled label={label} value={value} />
        <CopyToClipboard text={value} onCopy={this.markCopied}>
          <Button beforeSlot={<Icon name='CopyPaste' />}>
            {this.state.copied ? 'Copied!' : 'Copy'}
          </Button>
        </CopyToClipboard>
      </div>
    )
  }
}

export { TokenBanner }
export default connect(
  state => ({
    token: selectToken(state),
    error: selectError(state)
  }),
  { getRedirectToken }
)(TokenBanner)
